import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./activationCelebration.scss";

interface Props {
    onClose: () => void;
}

export function ActivationCelebration({ onClose }: Props) {
    const { t } = useTranslation();

    return createPortal(
        <div className="activ-overlay" role="dialog" aria-modal="true">
            <div className="activ-card">
                <div className="activ-illustration">
                    <svg viewBox="0 0 200 160" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        {/* Confetti dots */}
                        <circle cx="20"  cy="30"  r="5" fill="#0277bd" opacity="0.7" className="activ-confetti activ-confetti--1" />
                        <circle cx="175" cy="25"  r="4" fill="#f59e0b" opacity="0.8" className="activ-confetti activ-confetti--2" />
                        <circle cx="35"  cy="120" r="4" fill="#10b981" opacity="0.7" className="activ-confetti activ-confetti--3" />
                        <circle cx="165" cy="115" r="5" fill="#0277bd" opacity="0.6" className="activ-confetti activ-confetti--4" />
                        <circle cx="155" cy="50"  r="3" fill="#10b981" opacity="0.8" className="activ-confetti activ-confetti--5" />
                        <circle cx="40"  cy="60"  r="3" fill="#f59e0b" opacity="0.7" className="activ-confetti activ-confetti--6" />
                        <rect x="60" y="18" width="6" height="6" rx="1" fill="#f59e0b" opacity="0.7" transform="rotate(20 63 21)" className="activ-confetti activ-confetti--7" />
                        <rect x="130" y="130" width="6" height="6" rx="1" fill="#0277bd" opacity="0.6" transform="rotate(-15 133 133)" className="activ-confetti activ-confetti--8" />

                        {/* Stars */}
                        <path d="M28 55 l2 5 5 0 -4 3 1.5 5 -4.5-3 -4.5 3 1.5-5 -4-3 5 0z" fill="#f59e0b" className="activ-star activ-star--1" />
                        <path d="M170 70 l1.5 4 4 0 -3 2.5 1 4 -3.5-2.5 -3.5 2.5 1-4 -3-2.5 4 0z" fill="#0277bd" className="activ-star activ-star--2" />
                        <path d="M55 135 l1.5 4 4 0 -3 2.5 1 4 -3.5-2.5 -3.5 2.5 1-4 -3-2.5 4 0z" fill="#10b981" className="activ-star activ-star--3" />
                        <path d="M148 140 l1.5 4 4 0 -3 2.5 1 4 -3.5-2.5 -3.5 2.5 1-4 -3-2.5 4 0z" fill="#f59e0b" className="activ-star activ-star--4" />

                        {/* Central circle */}
                        <circle cx="100" cy="80" r="44" fill="#0277bd" opacity="0.1" />
                        <circle cx="100" cy="80" r="36" fill="#0277bd" opacity="0.15" />
                        <circle cx="100" cy="80" r="28" fill="#0277bd" />

                        {/* Checkmark */}
                        <polyline
                            points="88,80 97,90 114,70"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="activ-check"
                        />
                    </svg>
                </div>

                <h2 className="activ-title">{t("trial.activatedTitle")}</h2>
                <p className="activ-body">{t("trial.activatedBody")}</p>
                <p className="activ-signature">{t("trial.activatedSignature")}</p>

                <button className="activ-btn" onClick={onClose}>
                    {t("popup.ok")}
                </button>
            </div>
        </div>,
        document.body,
    );
}
